import { CLEAR_ACCESS_CONTROL, SET_ACCESS_CONTROL } from 'js/constants/actionTypes';
import { HYDRATE_FROM_LOCAL_STORE } from 'js/constants/actionTypes';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import LocalStorageUtils from 'js/lib/LocalStorageUtils';

type AccessControlAction = {
  payload: string;
};

const initialState = {
  mode: ACLQueryModeTypes.MODE_OWNER.key,
};

export const ACCESS_CONTROL_LOCALSTORAGE_KEY = 'access_level_mode';

const accessControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCESS_CONTROL:
      return setAccessControl(state, action);

    case CLEAR_ACCESS_CONTROL:
      return clearAccessControl();

    case HYDRATE_FROM_LOCAL_STORE:
      return hydrate(state, action);

    default:
      return state;
  }
};

function setAccessControl(state: { mode: string }, action: AccessControlAction) {
  const data = { mode: action.payload };
  LocalStorageUtils.saveObject(ACCESS_CONTROL_LOCALSTORAGE_KEY, action.payload);
  return { ...state, ...data };
}

function clearAccessControl() {
  return initialState;
}

function hydrate(state: { mode: string }, action: { mode: any }) {
  if (action.mode) {
    const data = { mode: action.mode };

    return {
      ...state,
      ...data,
    };
  }

  return state;
}

export { accessControlReducer };
